import "bootstrap/dist/css/bootstrap.css";
import * as React from "react";
import { createRoot } from 'react-dom/client';
import App from "./components/App/App";
import "./styles/index.css";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';  // Fixed import path

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

serviceWorkerRegistration.unregister();